define(["require", "exports", "jquery"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    $(function () {
        var $breadcrumb = $("ol.breadcrumb");
        var $title = $(".redakteur_detailView_text h1");
        if ($breadcrumb) {
            if ($title) {
                $breadcrumb.find("li").last().html($title.html());
            }
        }
    });
});
